// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__Z1y37","inner":"header_inner__KJ6rK","left":"header_left__Vq6x+","name":"header_name__l5s6-"};